<template>
  <div class="pay-wrap">
    <van-action-sheet v-model="show" title="选择付款方式">
      <div class="content">
        <div class="money-number"><span>¥</span>{{ money }}</div>
        <van-radio-group v-model="radio">
          <div class="items">
            <div class="item">
              <van-radio name="1" checked-color="#07c160"></van-radio>
              <div class="pay1"></div>
              微信支付
            </div>
            <!-- <div
              class="item"
              v-if="!getIsWxClient()"
            >
              <van-radio
                name="2"
                checked-color="#07c160"
              ></van-radio>
              <div class="pay2"></div>支付宝
            </div> -->
          </div>
        </van-radio-group>
        <div class="pay-btn" @click="payNow">立即付款</div>
      </div>
    </van-action-sheet>
  </div>
</template>
<script>
import { mapState } from 'vuex';
import axios from '../../http';

export default {
  name: 'pay',
  components: {},
  inject: ['reload'],
  props: {
    order: {
      type: String,
      default: '',
    },
    money: {
      type: Number,
      default: 0,
    },
    directPay: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      show: false,
      radio: '1',
    };
  },
  computed: {
    ...mapState(['token']),
  },
  watch: {},
  mounted() {},
  destroyed() {},
  methods: {
    payNow() {
      // debugger;
      // this.$emit("clickPayOne", { one: true });
      // console.log('this.getIsWxClient()', this.getIsWxClient());
      if (this.directPay) {
        //直接付款
        if (this.radio == '1') {
          if (this.getIsWxClient()) {
            //微信公众号支付 promise
            // console.log('微信公众号----支付');
            this.directWeixinAppPay();
          } else {
            //微信h5支付 Promise
            this.directWeixinH5Pay();
          }
        } else {
          //支付宝支付
          this.directZhifubaoPay();
        }
      } else {
        //差价支付
        if (this.radio == '1') {
          if (this.getIsWxClient()) {
            //微信公众号差价支付 promise
            // console.log('微信公众号----差价支付');
            this.weixinPayHApp();
          } else {
            //微信h5支付 Promise
            this.weixinPayH5();
          }
        } else {
          //支付宝支付
          this.zhifubaoPay();
        }
      }
    },
    getIsWxClient() {
      //判断是否在微信环境
      var ua = navigator.userAgent.toLowerCase();
      if (ua.match(/MicroMessenger/i) == 'micromessenger') {
        return true;
      } else {
        return false;
      }
    },
    weixinPayH5() {
      //差价微信H5
      axios
        .fetchPost('/api/order/wxpay_extend_h5', {
          token: this.token,
          order_sn: this.order,
        })
        .then((res) => {
          let data = res.data;
          if (data.code == 200) {
            this.$toast(data.msg);
            let payData = data.data;
            this.onBridgeReady(payData);
          }
          this.$toast(data.msg);
          this.show = false;
        })
        .catch((error) => {
          console.log('error :', error);
        });
    },
    weixinPayHApp() {
      //差价 微信App内部
      axios
        .fetchPost('/api/order/wxpay_extend_jsapi', {
          token: this.token,
          order_sn: this.order,
        })
        .then((res) => {
          // alert(res);
          let data = res.data;
          if (data.code == 200) {
            let payData = data.data;
            this.onBridgeReady(payData);
          }
          this.$toast(data.msg);
          this.show = false;
        })
        .catch((error) => {
          console.log('error :', error);
          alert(error);
        });
    },
    zhifubaoPay() {
      //差价支付宝支付
      axios
        .fetchPost('/api/order/alipay_extend', {
          token: this.token,
          order_sn: this.order,
        })
        .then((res) => {
          let data = res.data;
          this.$toast(data.msg);
          this.show = false;
          if (data.code == 200) {
            console.log('支付宝 :', data.data);
          }
        })
        .catch((error) => {
          console.log('error :', error);
        });
    },
    directWeixinH5Pay() {
      //直接微信H5支付
      axios
        .fetchPost('/api/order/wxpay_h5', {
          token: this.token,
          order_sn: this.order,
        })
        .then((res) => {
          let data = res.data;
          this.$toast(data.msg);

          if (data.code == 200) {
            this.show = false;
            // let payData = data.data;
            // console.log('data.data :>> ', data.data);
            // this.onBridgeReady(payData);
            window.location.href = data.data.mweb_url;
            // window.location.href = `${data.data.mweb_url}&redirect_url=${encodeURIComponent(
            //   'http://localhost:8000/#/secondBar/order'
            // )}`;
          }
        })
        .catch((error) => {
          console.log('error :', error);
        });
    },
    directWeixinAppPay() {
      //直接微信app 付款
      axios
        .fetchPost('/api/order/wxpay_jsapi', {
          token: this.token,
          order_sn: this.order,
        })
        .then((res) => {
          let data = res.data;
          this.show = false;
          if (data.code == 200) {
            let payData = data.data;

            this.onBridgeReady(payData);
          }
          this.$toast(data.msg);
        })
        .catch((error) => {
          console.log('error :', error);
        });
    },
    directZhifubaoPay() {
      //直接支付宝 付款
      axios
        .fetchPost('/api/order/alipay', {
          token: this.token,
          order_sn: this.order,
        })
        .then((res) => {
          let data = res.data;
          this.show = false;
          if (data.code == 200) {
            this.$toast(data.msg);
          }
        })
        .catch((error) => {
          console.log('error :', error);
        });
    },
    onBridgeReady(payData) {
      //获取appid之后支付
      let that = this;
      WeixinJSBridge.invoke(
        'getBrandWCPayRequest',
        {
          appId: payData.appId, //公众号名称，由商户传入
          timeStamp: payData.timeStamp, //时间戳，自1970年以来的秒数
          nonceStr: payData.nonceStr, //随机串
          package: payData.package,
          signType: payData.signType, //微信签名方式：
          paySign: payData.paySign, //微信签名
        },
        function(res) {
          if (res.err_msg == 'get_brand_wcpay_request:ok') {
            // 使用以上方式判断前端返回,微信团队郑重提示：
            //res.err_msg将在用户支付成功后返回ok，但并不保证它绝对可靠。
            let router = that.$route.path == '/secondBar/order';
            if (router) {
              setTimeout(() => {
                that.reload();
              }, 500);
              return;
            }
            setTimeout(() => {
              that.$router.replace({
                path: '/secondBar/order',
              });
            }, 500);
          } else {
            setTimeout(() => {
              that.reload();
            }, 500);
          }
        }
      );
    },
  },
};
</script>
<style lang="stylus" scoped>
.pay-wrap
  text-align center
  .content
    border-top 1px solid #e5e5e5
  .money-number
    color #282828
    font-size 25px
    font-weight 800
    margin 25px 0 10px
    & > span
      font-size 15px
      font-weight 500
  .items
    padding 0 15px
    text-align left
    & > .item
      border-bottom 1px solid #E5E5E5
      height 50px
      display flex
      align-items center
  .van-icon
    position absolute
    left 0
    top 12px
    font-size 20px
    width 20px
  .pay1
    width 20px
    height 20px
    background url('./pay1.png') no-repeat
    background-position center
    background-size 100%
    margin 0 10px 0 21px
  .pay2
    width 20px
    height 20px
    background url('./pay2.png') no-repeat
    background-position center
    background-size 100%
    margin 0 10px 0 21px
  .pay-btn
    height 40px
    line-height 40px
    color #fff
    margin 20px 15px 12px
    background rgba(85, 204, 153, 1)
    border-radius 5px
</style>
